(function(){
  function each(list,fn){for(var k=0;k<list.length;k++)fn(list[k],k);}
  function pad(n){return (n<10?'0':'')+n;}
  function eager(s){if(s)each(s.querySelectorAll('img'),function(im){if(im.loading!=='eager')im.loading='eager';});}
  function ready(s,cb){
    var im=s.querySelector('.on-frame img.is-on')||s.querySelector('.on-frame img'), done=false;
    function f(){if(done)return;done=true;cb();}
    if(!im||(im.complete&&im.naturalWidth)){f();return;}
    im.addEventListener('load',f,{once:true});im.addEventListener('error',f,{once:true});setTimeout(f,1400);
  }
  function init(root){
    if(!root||root.dataset.ready)return; root.dataset.ready='1';
    var slides=[].slice.call(root.querySelectorAll('.on-slide')), metas=root.querySelectorAll('.on-meta'),
        ambs=root.querySelectorAll('.on-amb i'), chips=root.querySelectorAll('[data-go]'),
        cur=root.querySelector('[data-cur]'), num=root.querySelector('.on-num'), bar=root.querySelector('.on-bar i'),
        stage=root.querySelector('.on-stage'), N=slides.length, i=0, timer=null, visible=false, hold=false, pending=-1,
        sec=parseInt(root.dataset.autoplay,10)||0, delay=Math.max(3,sec)*1000, auto=sec>0, pauseT=null, outT=null;
    if(!N)return;
    function pauseFor(ms){hold=true;clearTimeout(pauseT);pauseT=setTimeout(function(){hold=false;restart();},ms);}
    function go(n){
      n=(n+N)%N; if(n===i||n===pending)return;
      pending=n; clearTimeout(timer); eager(slides[n]);
      ready(slides[n],function(){
        if(pending!==n)return; pending=-1;
        var old=slides[i];
        each(slides,function(s){s.classList.remove('is-out');});
        old.classList.remove('is-on'); old.classList.add('is-out');
        clearTimeout(outT); outT=setTimeout(function(){old.classList.remove('is-out');},1300);
        i=n; slides[i].classList.add('is-on'); eager(slides[(i+1)%N]);
        each(metas,function(m,k){m.classList.toggle('is-on',k===i);});
        each(ambs,function(a,k){a.classList.toggle('is-on',k===i);});
        each(chips,function(c,k){c.setAttribute('aria-pressed',k===i?'true':'false');});
        if(chips[i]){var st=chips[i].parentNode;if(st.scrollWidth>st.clientWidth)st.scrollTo({left:chips[i].offsetLeft-st.offsetLeft-20,behavior:'smooth'});}
        if(cur)cur.textContent=pad(i+1); if(num)num.textContent=pad(i+1);
        restart();
      });
    }
    function restart(){
      clearTimeout(timer);
      if(bar){bar.style.transition='none';bar.style.transform='scaleX(0)';}
      if(!auto||!visible||hold)return;
      if(bar){void bar.offsetWidth;bar.style.transition='transform '+delay+'ms linear';bar.style.transform='scaleX(1)';}
      timer=setTimeout(function(){go(i+1);},delay);
    }
    var pv=root.querySelector('[data-prev]'), nx=root.querySelector('[data-next]');
    if(pv)pv.addEventListener('click',function(){pauseFor(8000);go(i-1);});
    if(nx)nx.addEventListener('click',function(){pauseFor(8000);go(i+1);});
    each(chips,function(c,k){c.addEventListener('click',function(){pauseFor(8000);go(k);});});
    each(slides,function(s){
      var imgs=s.querySelectorAll('.on-frame img'), btns=s.querySelectorAll('[data-angle]');
      each(btns,function(b,k){b.addEventListener('click',function(){
        if(imgs[k])imgs[k].loading='eager';
        each(imgs,function(im,j){im.classList.toggle('is-on',j===k);});
        each(btns,function(x,j){x.setAttribute('aria-pressed',j===k?'true':'false');});
        pauseFor(8000);
      });});
      var fr=s.querySelector('.on-frame');
      if(fr&&window.matchMedia('(hover:hover)').matches){
        fr.addEventListener('pointermove',function(e){var r=fr.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;fr.style.transform='rotateY('+(x*5)+'deg) rotateX('+(-y*5)+'deg)';});
        fr.addEventListener('pointerleave',function(){fr.style.transform='';});
      }
    });
    var sx=null,sy=null;
    if(stage){
      stage.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;sy=e.touches[0].clientY;},{passive:true});
      stage.addEventListener('touchend',function(e){if(sx===null)return;var dx=e.changedTouches[0].clientX-sx,dy=e.changedTouches[0].clientY-sy;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)){pauseFor(8000);go(i+(dx<0?1:-1));}sx=null;},{passive:true});
    }
    root.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){go(i+1);}else if(e.key==='ArrowLeft'){go(i-1);}else if(e.key==='Escape'){closeLb();}});
    var lb=root.querySelector('[data-lb]'), lbImg=lb&&lb.querySelector('img');
    function closeLb(){if(!lb)return;lb.classList.remove('is-on');document.documentElement.style.overflow='';hold=false;restart();}
    each(root.querySelectorAll('[data-zoom]'),function(z){z.addEventListener('click',function(){
      var im=slides[i].querySelector('.on-frame img.is-on'); if(!im||!lb)return;
      lbImg.src=(im.currentSrc||im.src).replace(/([?&])width=[0-9]+/,'$1width=2000'); lbImg.alt=im.alt; lb.classList.add('is-on'); hold=true; restart();
      document.documentElement.style.overflow='hidden'; lb.querySelector('button').focus();
    });});
    if(lb)lb.addEventListener('click',function(e){if(e.target===lb||e.target.hasAttribute('data-lbclose'))closeLb();});
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){var v=en[0].isIntersecting;if(v!==visible){visible=v;restart();}},{threshold:.2}).observe(root);
    } else { visible=true; restart(); }
    document.addEventListener('visibilitychange',function(){if(!document.hidden)restart();});
    eager(slides[0]); eager(slides[1%N]);
    document.addEventListener('shopify:block:select',function(e){if(!root.contains(e.target))return;each(metas,function(m,k){if(m===e.target||m.contains(e.target)){pauseFor(15000);go(k);}});});
  }
  function boot(){each(document.querySelectorAll('.rpa-on'),init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('.rpa-on');if(r)init(r);});
})();